import _ from 'underscore';
import $ from 'jquery';
import URI from 'urijs';

import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import { gridsType } from './constants';

const i18nGlobal = globalContext.require('$/i18n!legacy/global');
const globalConfig = globalContext.require('component/config/index');
const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');

const {
  IsCustomerHierarchyEnabled,
  IsNewBillToCustomerHierarchyEnabled,
  IsReactivateAccountEnabled,
  IsEditAccountEnabled,
  IsDeleteAccountEnabled,
  IsCreateAccountEnabled,
  IsLinkAccountEnabled,
  IsUnlinkAccountEnabled,
  IsTransferAccountEnabled,
  IsManagementDashboardEnabled,
  IsInternalUser,
} = globalConfig.get('Permissions');

export const navigate = (url) => {
  window.location.href = url;
};

export const currentCid = () => {
  const customer = globalConfig.get('CurrentCustomer') || {};

  return customer.Id || $.advertiser.getUrlParameter('cid');
};

export const currentCustomer = () => {
  const customer = globalConfig.get('CurrentCustomer') || {};

  return customer.Name || '';
};

export const parentCustomerCid = () => globalConfig.get('ParentCustomerId');

export const currentUid = () => {
  const currentUser = globalConfig.get('CurrentUser') || {};

  return currentUser.Id || $.advertiser.getUrlParameter('uid');
};

// the name column should not be renamed, otherwise there'll be requirejs error
export function column(options) {
  return bingadsGridColumn(_.defaults({}, options, { i18n: i18nGlobal }));
}

export const buildVNextColumn = i18n => options => bingadsGridColumn(_.defaults({}, options, { i18n }));

// Some row in grid has special usage, like aggregated row.
export const isAccountItemRow = item => !_.isEmpty(item) && !_.isEmpty(item.AccountNumber);

export const isAdAccount = account => isAccountItemRow(account) && (!IsCustomerHierarchyEnabled || account.AccountType === 'AdAccount');

export const isManagerAccount = account => isAccountItemRow(account) && IsCustomerHierarchyEnabled && account.AccountType === 'ManagerAccount';

export const isInImportTab = gridType => gridType === gridsType.import;

export const isInManagementOrBudgetTab = gridType => gridType === gridsType.budget || gridType === gridsType.management;

export const isInPerformanceTab = gridType => gridType === gridsType.performance;

export const isInSmartPerformanceTab = gridType => gridType === gridsType.smartPerformance;

export const getGridPermissions = ({ gridType }) => {
  let createAccount = false;
  let checkAndDeleteAccount = false;
  let checkAndReactivateAccount = false;
  let linkAccount = false;
  let checkAndUnlinkAccount = false;
  let checkAndTransferAccount = false;
  let checkAndEditAccount = false;
  let exportAccount = false;
  let importFromGoogleAds = false;
  const isImportGrid = isInImportTab(gridType);

  if (!isImportGrid && (IsManagementDashboardEnabled || IsCustomerHierarchyEnabled)) {
    createAccount = IsCreateAccountEnabled;
    if (createAccount &&
      IsCustomerHierarchyEnabled &&
      !IsNewBillToCustomerHierarchyEnabled &&
      parentCustomerCid() !== 0 && parentCustomerCid() !== currentCid()) {
      createAccount = false;
    }
    checkAndUnlinkAccount = IsUnlinkAccountEnabled;
    linkAccount = IsLinkAccountEnabled;
  }

  const isManagementGrid = isInManagementOrBudgetTab(gridType);

  checkAndTransferAccount = IsManagementDashboardEnabled && IsTransferAccountEnabled && IsInternalUser;
  if (isManagementGrid) {
    checkAndDeleteAccount = IsManagementDashboardEnabled && IsDeleteAccountEnabled;
    checkAndReactivateAccount = IsManagementDashboardEnabled && IsReactivateAccountEnabled;
    checkAndEditAccount = IsManagementDashboardEnabled && IsEditAccountEnabled;
    exportAccount = IsManagementDashboardEnabled;
  }

  if (isImportGrid) {
    importFromGoogleAds = true;
  }
  const checkboxColumns = checkAndDeleteAccount || checkAndReactivateAccount || checkAndUnlinkAccount || checkAndTransferAccount || checkAndEditAccount || importFromGoogleAds;

  return {
    createAccount,
    checkAndDeleteAccount,
    checkAndReactivateAccount,
    linkAccount,
    checkAndUnlinkAccount,
    checkAndTransferAccount,
    checkAndEditAccount,
    exportAccount,
    checkboxColumns,
    importFromGoogleAds,
  };
};

export const getSwitchCustomerShellLink = cid => new URI(window.location.href)
  .setSearch('cid', String(cid))
  .removeSearch('uid')
  .removeSearch('aid')
  .hash('')
  .toString();

export const getVNextCampaignWithCidAndAid = (cid, aid) => `/campaign/vnext?cid=${cid}&uid=${currentUid()}&aid=${aid}`;

export const getVNextCampaignWithAid = aid => `/campaign/vnext?cid=${currentCid()}&uid=${currentUid()}&aid=${aid}`;

export const getVNextAccountsSummaryWithCid = cid => `/campaign/vnext/Accounts?cid=${cid}&uid=${currentUid()}`;
